<template>
  <li>
    <team-member-avatar :subject="comment.commenter" height="45px" width="45px" v-if="showAvatar"></team-member-avatar>

    <span class="commenter-comment">
      <p class="name">
        {{ comment.commenter.name }}
        <span class="time pull-right">{{ comment.created_at | utcFromNow }}</span>
      </p>
      <p class="comment-header" v-if="showHeader">
        <router-link :to="'/a/document/' + comment.document.id">{{ comment.document.title }}</router-link>
      </p>
      <p class="comment" v-html="commentType === 'full' ? commentBodyFormatted : comment.excerpt"></p>
    </span>
  </li>
</template>

<script>
import { utcTimeZones } from 'mixins/time';

export default {
  mixins: [utcTimeZones],
  props: ['comment', 'showAvatar', 'showHeader', 'commentType'],
  computed: {
    commentBodyFormatted() {
      return this.comment.body
        .replace(/([a-z0-9_\.\-\+])+\@(([a-z0-9\-])+\.)+([a-z0-9]{2,4})+/gi, '<span class="email">$&</span>')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "resources/assets/sass/layout/_variables";

  li {
    list-style: none;
    border: none;
    padding: 0;
    margin-bottom: 30px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    .commenter-comment {
      width: 87%;
      padding-left: 5%;
      p {
        &.name {
          font-weight: 700;
          font-size: 13px;
          .status {
            width: 12px;
            height: 12px;
            background: $mutedblue;
            border-radius: 100px;
            border: 2px solid $white;
            display: inline-block;
            &.online {
              background: $green;
            }
          }
          .time {
            font-weight: 300;
            font-size: 12px;
            float: right;
          }
        }
        &.comment-header {
          font-weight: 700;
          font-size: 13px
        }

        &.comment {
          font-size: 13px;

          /deep/ .email {
            font-weight: bold;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// comment.vue?6a79371e